
<div class="pointer--wrapper">
  <div class="pointer size size-{{size}}">
    <div class="out"></div>
    <!-- <div class="in"></div> -->
  </div>
  <ng-container *ngIf="size === Size.Plan">
    <div class="pointer--name">{{ name }}</div>
  </ng-container>
</div>
